import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=dd8a28a8&scoped=true&"
import script from "./KeyFeatures.vue?vue&type=script&lang=js&"
export * from "./KeyFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8a28a8",
  null
  
)

export default component.exports